import { request } from "../../utils/config"

// tog'a #3563 2-qism (2026-10-07): «Заявки партнёров» — admin API.
// Shartnoma: docs/plans/HAMKOR-ARIZA-3563-2026-10-07.md («API SHARTNOMASI»), JSON camelCase.

export type PAppKind = "shop" | "counterparty"

/** Holatlar: 0 Новая, 1 На проверке, 2 Нужны данные, 3 Одобрена, 4 Отклонена */
export const PAPP_STATUS: Record<number, { key: string; color: string; cls: string }> = {
  0: { key: "paSt0", color: "blue", cls: "new" },
  1: { key: "paSt1", color: "orange", cls: "review" },
  2: { key: "paSt2", color: "purple", cls: "need" },
  3: { key: "paSt3", color: "green", cls: "approved" },
  4: { key: "paSt4", color: "red", cls: "rejected" },
}
export const PAPP_STATUSES = [0, 1, 2, 3, 4]

export interface PAppRow {
  id: number
  number: string
  inserted: string
  kind: PAppKind
  companyName: string
  personName: string
  phone: string
  phoneVerified: boolean
  region: string
  email?: string | null
  status: number
  statusName?: string | null
  reviewedByName?: string | null
  approvedTenantId?: number | null
}

export interface PAppList {
  data: PAppRow[]
  totalRecords: number
  counts?: Record<string, number>
}

export interface PAppDuplicate {
  type: "counterparty" | "shop" | "application" | "user"
  id: number
  name?: string | null
  phone?: string | null
  matchBy: "phone" | "name" | "email"
}

export interface PAppLog {
  inserted: string
  oldStatus?: number | null
  newStatus: number
  note?: string | null
  userName?: string | null
}

export interface PAppDetail extends PAppRow {
  address?: string | null
  note?: string | null
  lang?: string | null
  statusReason?: string | null
  telegramLinked?: boolean
  approvedCounterpartyId?: number | null
  approvedShopId?: number | null
  duplicates?: PAppDuplicate[]
  log?: PAppLog[]
}

export interface PAppApproveInput {
  kind: PAppKind
  name: string
  warehouseId?: number | null
  managerId?: number | null
  partnerRoleId?: number | null
  orderScope?: "all" | "showcase" | null
  email: string
  password?: string | null
}

export interface PAppApproveResult {
  tenantId: number
  counterpartyId?: number | null
  shopId?: number | null
  login: string
  password: string
  sentToTelegram: boolean
}

export interface PartnerRoleOpt {
  id: number
  name: string
  isDefault: boolean
}

export const GET_PARTNER_APPS = async (p: { status?: number | null; kind?: string | null; q?: string; pageNumber: number; pageSize: number }) => {
  const params: any = { PageNumber: p.pageNumber, PageSize: p.pageSize }
  if (p.status !== null && p.status !== undefined) params.status = p.status
  if (p.kind) params.kind = p.kind
  if (p.q) params.q = p.q
  const r = await request({ url: "PartnerApplications", params })
  return r.data as PAppList
}

export const GET_PARTNER_APP = async (id: number) => {
  const r = await request({ url: `PartnerApplications/${id}` })
  return r.data as PAppDetail
}

/** Menyu nishoni uchun: yangi (status 0) arizalar soni. Jim — eski backend/403 da toast chiqmaydi. */
export const GET_PARTNER_APPS_NEW_COUNT = async () => {
  const r = await request({ url: "PartnerApplications/NewCount", silent: true })
  return Number(r?.data?.count || 0)
}

/** status: 1 На проверке, 2 Нужны данные, 4 Отклонена (2 va 4 da sabab majburiy). Javob — karta (GET {id} bilan bir xil) + sentToTelegram */
export const SET_PARTNER_APP_STATUS = async (id: number, status: 1 | 2 | 4, reason?: string | null) => {
  const r = await request({ url: `PartnerApplications/${id}/Status`, method: "PUT", data: { status, reason: reason ?? null } })
  return r.data as (PAppDetail & { sentToTelegram?: boolean }) | null
}

/** Arizani o'chirish (yumshoq). Hamkor va uning tizimi (yaratilgan bo'lsa) o'chirilmaydi. → {id, deleted:true} */
export const DELETE_PARTNER_APP = async (id: number) => {
  const r = await request({ url: `PartnerApplications/${id}`, method: "DELETE" })
  return r.data as { id: number; deleted: boolean }
}

export const APPROVE_PARTNER_APP = async (id: number, data: PAppApproveInput) => {
  const r = await request({ url: `PartnerApplications/${id}/Approve`, method: "POST", data })
  return r.data as PAppApproveResult
}

/** Hamkor rollari (1-qism): [{id,name,isDefault}] — faqat glavniy super-admin uchun ochiq, boshqasiga 403 (jim) */
export const GET_PARTNER_ROLE_OPTIONS = async (kind: PAppKind) => {
  const r = await request({ url: "Tenants/PartnerRoles", params: { kind }, silent: true })
  return (Array.isArray(r?.data) ? r.data : []) as PartnerRoleOpt[]
}
